import api from './api-caller';
import utils from '../mixins/utils';
const { getOrganizationPublicId } = utils.methods;

const baseEndpoint = '/organizations';


export default {
    listUsers: () => {
        let endpoint = `${baseEndpoint}/${getOrganizationPublicId()}/users`;
        return api(endpoint, 'GET')
    },
    deleteUser: (userID) => {
        let endpoint = `${baseEndpoint}/${getOrganizationPublicId()}/users/${userID}`;
        return api(endpoint, 'DELETE')
    },
    createUser: (createUser) => {
        let endpoint = `${baseEndpoint}/${getOrganizationPublicId()}/users/`;
        return api(endpoint, 'POST', createUser)
    },
    editUser: (userID, editUser) => {
        let endpoint = `${baseEndpoint}/${getOrganizationPublicId()}/users/${userID}`;
        return api(endpoint, 'PUT', editUser);
    }
}
